import { time } from '@/lib/util'
import styles from '@/styles/Home.module.scss'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'

const nowDate = () => {
  const date = new Date()
  return (
    date.getFullYear() + '年' + ('0' + (date.getMonth() + 1)).slice(-2) + '月' + ('0' + date.getDate()).slice(-2) + '日'
  )
}

const CampaignComponents = memo(
  ({
    campaign,
    showCampaignDescription = true,
  }: { campaign: Api.CampaignResBody; showCampaignDescription?: boolean }) => {
    const { t, i18n } = useTranslation()
    const date = nowDate()

    return (
      <>
        <div className={styles.c_main_visual}>
          <img src={campaign.image} alt="" />
        </div>
        {campaign.period && campaign.isDisplayEventPeriod ? (
          <div className={styles.c_period_wrap}>
            <p className={`text-sm ${styles.c_period}`}>
              {t('home.event_period', '開催期間')}
              <br />
              {time({ time: campaign.viewStartAt, language: i18n.language })} ~{' '}
              {time({ time: campaign.viewEndAt, language: i18n.language })}
            </p>
          </div>
        ) : (
          ''
        )}

        {campaign.period ? (
          ''
        ) : (
          <div className={styles.c_period_wrap}>
            {campaign.viewStartAt > date ? (
              <p className={`text-sm ${styles.c_period}`}>
                {campaign.name}はイベント期間前です。
                <span className="block">
                  {t('home.event_period', '開催期間')}:
                  {time({
                    time: campaign.viewStartAt,
                    language: i18n.language,
                  })}{' '}
                  ~{' '}
                  {time({
                    time: campaign.viewEndAt,
                    language: i18n.language,
                  })}
                </span>
              </p>
            ) : (
              ''
            )}
            {campaign.viewEndAt < date ? (
              <>
                <p className={`text-sm ${styles.c_period}`}>{campaign.name}のイベントは終了しました。</p>
              </>
            ) : (
              ''
            )}
          </div>
        )}

        <section className="c-shadow_top bg-white py-6">
          <div className={showCampaignDescription ? `l-inner` : ''}>
            {campaign.isDisplayCampaignName ? (
              <h1
                className="text-center text-h1 font-bold"
                dangerouslySetInnerHTML={{
                  __html: `${campaign.name}`,
                }}
              />
            ) : (
              ''
            )}
            {showCampaignDescription && (
              <p
                className="mt-2 text-sm"
                dangerouslySetInnerHTML={{
                  __html: `${campaign.description}`,
                }}
              />
            )}
          </div>
        </section>
      </>
    )
  },
)

CampaignComponents.displayName = 'CampaignComponents'

export default CampaignComponents
